var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/*
 * Copyright (c) 2022 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2022-10-12
 * @brief EHP 이메일 상담 개발
 *
 ********************************************************************/
import React, { useEffect, useRef, useState } from "react";
//
import { useAsync } from "react-async";
// recoil && state
import { useRecoilValue, } from "recoil";
import { userInfoLoginState } from "../../../recoil/userState";
//
import * as HTTPUTIL from "../../../utils/api/HttpUtil";
import clog from "../../../utils/logUtils";
import * as CUTIL from "../../../utils/commUtils";
import * as CONST from "../../../utils/Const";
import { useNavigate } from "react-router-dom";
/**
 * @brief EHP 이메일 상담 컴포넌트, 반응형 동작
 * @param -
 * @returns react components
 */
function InquiryView(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //화면 이동
    const navigate = useNavigate();
    //props
    const setParentPopWin = props.setPopWin;
    //
    const [userItem, setUserItem] = useState(null);
    //  
    const [subject, setSubject] = useState("");
    const [malfunctionItem] = useState([
        { "id": 0, "fnName": "e-Health Portal 문의", "value": "" },
        { "id": 1, "fnName": "기타 문의", "value": "" },
    ]);
    /*   const [agreeMailReceipt, setAgreeMailReceipt] = useState(true);
      const [agreePortalAlarm, setAgreePortalAlarm] = useState(false); */
    const [agreePersonalInfoSel, setAgreePersonalInfoSel] = useState("true");
    const [errorList, setErrorList] = useState([]);
    const [content, setContent] = useState("");
    const [malfunction, setMalfunction] = useState("");
    const agreePersonalInfo = (agreePersonalInfoSel == "true") ? true : false;
    const [savedFiles, setSavedFiles] = useState([]);
    const [curPos] = useState(0);
    const [listSize] = useState(10);
    const fileRef = useRef();
    const [success, setSuccess] = useState("");
    const errorRef = useRef();
    // user Info API
    const { data: data, error, isLoading, reload, run, } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/api/v2/user`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
    });
    useEffect(() => {
        // error page 이동
        const ERR_URL = HTTPUTIL.resultCheck(isLoading, data);
        if (ERR_URL.length > 0)
            navigate(ERR_URL);
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setUserItem(data.body);
                // setCompanyDto(data.body);
            }
        }
    }, [data]);
    // 내용
    function handlesSubject(e) {
        setErrorList(errorList.filter((err) => (err.field !== "subject")));
        setSubject(e.target.value);
    }
    // 문의 유형 API
    // 문의 유형 선택 - select
    function malfunctionSelect(malfunction) {
        setErrorList(errorList.filter((err) => (err.field !== "consultType")));
        setMalfunction(malfunction.fnName);
    }
    // 내용
    function handleContent(e) {
        setErrorList(errorList.filter((err) => (err.field !== "content")));
        setContent(e.target.value);
    }
    // 첨부파일 
    function handleFileUpload(e) {
        fileRef.current.click();
    }
    // 첨부파일 저장
    function saveFileImage(e) {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("files", file);
        var fileVal = {
            imageId: "INS_" + savedFiles.length,
            name: file.name,
            url: URL.createObjectURL(file),
            type: "INS",
            fileForm: formData,
        };
        if (savedFiles.length <= 9) {
            setSavedFiles([...savedFiles, fileVal]);
            e.target.value = ''; // file name 초기화
        }
        else {
            alert("첨부파일은 10개 까지 가능합니다.");
        }
    }
    ;
    // 이미지 삭제
    function onClickAttachFileDelete(delFile) {
        //var delFile = savedFiles[idx];
        if (!delFile.hasOwnProperty("type")) {
            URL.revokeObjectURL(delFile.url);
        }
        setSavedFiles(savedFiles.filter(file => file.imageId !== delFile.imageId));
    }
    //동의
    function handleAgreePersonalInfoSelSel(e) {
        setAgreePersonalInfoSel(e.target.value);
    }
    // 요청 팝업
    useEffect(() => {
        setParentPopWin("pop-small", React.createElement(RequestDoenPop, { htmlHeader: (data) && React.createElement("h1", null, (success) ? "저장" : "이메일 상담"), success: success, data: data, requestSaved: requestSaved, requestDone: requestDone }));
    });
    // 미동의
    function disagreePop(e) {
        setParentPopWin("pop-small", React.createElement(DisagreePop, { htmlHeader: React.createElement("h1", null, "\uC5D0\uB7EC"), success: success, requestSaved: requestSaved, requestDone: requestDone }));
        CUTIL.jsopen_Popup(e);
    }
    // 요청 점검  API
    function requestSaved(e, userItem) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = {};
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/api/v2/board/consult`,
                appQuery: {
                    userIdPk: userItem.userIdPk,
                    /*      agreeMailReceipt: agreeMailReceipt,
                         agreePortalAlarm: false, */
                    agreePersonalInfo: agreePersonalInfo,
                    consultType: malfunction,
                    subject: subject,
                    content: content
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    if (savedFiles.length == 0) {
                        setSuccess(data.data.msg);
                    }
                    else {
                        savedFiles.map((file, idx) => {
                            if (file.hasOwnProperty("type") && (file.type == "INS")) {
                                saveFiles(data.body.id, file.fileForm);
                            }
                        });
                        setSuccess(data.data.msg);
                    }
                }
                else {
                    setErrorList((data.errorList == null) ? [] : data.errorList);
                    var btnCommentClose = document.getElementById("pop-small");
                    var body = document.body;
                    var dimm = body.querySelector(".dimm");
                    if (!CUTIL.isnull(btnCommentClose))
                        btnCommentClose.classList.add("hidden");
                    if (!CUTIL.isnull(body))
                        body.setAttribute("style", "overflow-y: auto;");
                    if (!CUTIL.isnull(dimm))
                        dimm.setAttribute("style", "display: none; z-index: 11;");
                    errorRef.current.focus();
                }
            }
        });
    }
    // 첨부파일 API
    function saveFiles(itemId, fileFormData) {
        return __awaiter(this, void 0, void 0, function* () {
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                "httpMethod": "POST",
                "appPath": `/api/v2/board/consult/files?consultId=${itemId}`,
                appQuery: fileFormData,
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == 200) {
                    clog("IN CHECK ITEM LAST : saveFiles : " + JSON.stringify(data));
                }
                else { // api if
                    // need error handle
                    alert(data.errorList.map((err) => err.msg));
                }
            }
            //return data;
        });
    }
    function requestDone(e) {
        window.location.reload();
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "box__header" },
            React.createElement("h2", null, "\uC774\uBA54\uC77C \uC0C1\uB2F4"),
            React.createElement("p", { className: "box__title" }, "e-Health Portal \uBC0F \uC81C\uD488\uC5D0 \uB300\uD558\uC5EC \uC774\uBA54\uC77C \uC0C1\uB2F4\uC744 \uC81C\uACF5\uD574 \uB4DC\uB9BD\uB2C8\uB2E4."),
            React.createElement("ul", { className: "box__info" },
                React.createElement("li", null, "e-Health Portal \uC774\uC6A9 \uC911\uC5D0 \uC0DD\uAE34 \uBD88\uD3B8\uD55C \uC810\uC774\uB098 \uBB38\uC758\uC0AC\uD56D\uC744 \uBCF4\uB0B4\uC8FC\uC138\uC694. \uAD81\uAE08\uD558\uC2E0 \uC810\uC744 \uB0A8\uACA8\uC8FC\uC2DC\uBA74 \uCD5C\uCD08 \uC811\uC218\uB41C \uBB38\uC758 \uAC74\uBD80\uD130 \uC21C\uCC28\uC801\uC73C\uB85C \uB2F5\uBCC0\uC744 \uBC1B\uC73C\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                React.createElement("li", null, "\uC774\uBA54\uC77C \uC0C1\uB2F4\uC740 \uC2E4\uC2DC\uAC04 \uC0C1\uB2F4\uC774 \uC544\uB2C8\uBA70, \uC0C1\uB2F4\uC774 \uC9D1\uC911\uB420 \uACBD\uC6B0 \uB2F5\uBCC0\uC774 \uC9C0\uC5F0\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                React.createElement("li", null, "\uB124\uD2B8\uC6CC\uD06C \uC7A5\uC560 \uB4F1\uC73C\uB85C \uB0B4\uC6A9 \uC800\uC7A5\uC774 \uC548 \uB420 \uC218 \uC788\uC73C\uB2C8 \uBA54\uBAA8\uC7A5 \uB4F1\uC5D0\uC11C \uC791\uC131\uD558\uC5EC \uB4F1\uB85D\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4."))),
        React.createElement("div", { className: "box__body" },
            (userItem) &&
                React.createElement("div", { className: "info__input" },
                    React.createElement("div", { className: "page-top" },
                        React.createElement("h3", null,
                            React.createElement("span", null, "1. \uC0C1\uB2F4 \uC785\uB825"),
                            React.createElement("span", { className: "txt-info" },
                                React.createElement("span", { className: "txt-red mr-4" }, "*"),
                                "\uD544\uC218 \uC785\uB825 \uC0AC\uD56D"))),
                    React.createElement("div", { className: "content__info" },
                        React.createElement("ul", { className: "form__input" },
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit star" }, "\uC81C\uBAA9"),
                                React.createElement("input", { className: "hide", ref: errorRef }),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("p", { className: "txtnum" },
                                        subject.length,
                                        " / 100"),
                                    React.createElement("input", { type: "text", value: subject, onKeyPress: (e) => CUTIL.beforeHandleComment(e, 100), onKeyUp: (e) => CUTIL.afterHandleComment(e, 100, setSubject), onChange: (e) => handlesSubject(e), className: `${(errorList.filter(err => (err.field === "subject")).length > 0) && " input-error"}` }),
                                    React.createElement("p", { className: "input-errortxt" }, errorList.filter(err => (err.field === "subject")).map((err) => err.msg)))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit star" }, "\uBB38\uC758 \uC720\uD615"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("div", { className: `select ${(errorList.filter(err => (err.field === "consultType")).length > 0) && " input-error"}`, onClick: (e) => CUTIL.onClickSelect(e, CUTIL.selectOption) },
                                        React.createElement("div", { className: "selected" },
                                            React.createElement("div", { className: "selected-value" }, "\uC120\uD0DD"),
                                            React.createElement("div", { className: "arrow" })),
                                        React.createElement("ul", null, (malfunctionItem) && malfunctionItem.map((type, idx) => (React.createElement("li", { key: "malfunction_" + idx.toString(), className: "option", onClick: (e) => malfunctionSelect(type) }, type.fnName))))))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uC774\uB984"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { readOnly: true, type: "text", value: userItem.userName, disabled: true }))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "E-MAIL"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { readOnly: true, type: "text", value: userItem.userId, disabled: true }))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uC5F0\uB77D\uCC98"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("input", { readOnly: true, type: "text", value: userItem.phoneNumber, disabled: true }))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uB0B4\uC6A9"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("textarea", { className: `h130 ${(errorList.filter((err) => (err.field == "content")).length > 0) ? "input-error" : ""} `, placeholder: "\uD14D\uC2A4\uD2B8\uB97C \uC785\uB825\uD558\uC138\uC694.", value: content, onChange: (e) => handleContent(e) }),
                                    React.createElement("p", { className: "input-errortxt top-148" }, "\uD544\uC218 \uC785\uB825 \uD56D\uBAA9\uC785\uB2C8\uB2E4."))),
                            React.createElement("li", null,
                                React.createElement("p", { className: "tit" }, "\uCCA8\uBD80\uD30C\uC77C"),
                                React.createElement("div", { className: "input__area" },
                                    React.createElement("div", { className: "filebox" },
                                        React.createElement("input", { readOnly: true, className: "upload-name", placeholder: "\uC0AC\uC9C4\uC744 \uCCA8\uBD80\uD558\uC138\uC694" }),
                                        React.createElement("label", { onClick: (e) => handleFileUpload(e) },
                                            React.createElement("span", { className: "hide" }, "\uD30C\uC77C\uCC3E\uAE30")),
                                        React.createElement("input", { ref: fileRef, type: "file", id: "file", accept: "image/jpg, image/jpeg, image/png", onChange: (e) => saveFileImage(e) })),
                                    React.createElement("ul", { className: "filelist" }, savedFiles.filter((file, idx) => (idx >= curPos) && ((idx < curPos + listSize))).map((img) => (React.createElement("li", { key: img.imageId },
                                        React.createElement("span", null, img.name),
                                        React.createElement("button", { type: "button", className: "btn btn-delete", onClick: (e) => onClickAttachFileDelete(img) },
                                            React.createElement("span", { className: "hide" }, "\uC0AD\uC81C")))))),
                                    React.createElement("p", { className: "txt-info mt-16 mb-0" }, " \uCCA8\uBD80\uD30C\uC77C\uC740 10\uAC1C \uC774\uD558, \uC804\uCCB4 120M\uAE4C\uC9C0 \uAC00\uB2A5\uD569\uB2C8\uB2E4")))))),
            React.createElement("div", { className: "info__input" },
                React.createElement("div", { className: "page-top" },
                    React.createElement("h3", null,
                        React.createElement("span", { className: "star" }, "\uB3D9\uC758"),
                        React.createElement("span", { className: "txt-info" },
                            React.createElement("span", { className: "txt-red mr-4" }, "*"),
                            "\uD544\uC218 \uC785\uB825 \uC0AC\uD56D"))),
                React.createElement("div", { className: "content__info" },
                    React.createElement("ul", { className: "form__input" },
                        React.createElement("li", { className: "column" },
                            React.createElement("p", { className: "tit mt-0" }, "'\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC \uBC29\uCE68' \uACF5\uC9C0 \uBC0F '\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC \uBC29\uCE68' \uC5D0 \uB3D9\uC758\uD558\uC2ED\uB2C8\uAE4C?"),
                            React.createElement("div", { className: "input__area" },
                                React.createElement("ul", { className: "terms" },
                                    React.createElement("li", { className: "mb-0" },
                                        React.createElement("div", { className: "box-scroll" },
                                            React.createElement("p", { className: "txt" },
                                                "[\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC\uBC29\uCE68 \uAC1C\uC694]",
                                                React.createElement("br", null),
                                                React.createElement("br", null),
                                                "LS ELECTRIC\uC740 \uC815\uBCF4\uD1B5\uC2E0\uB9DD \uC774\uC6A9\uCD09\uC9C4 \uBC0F \uC815\uBCF4\uBCF4\uD638 \uB4F1\uC5D0 \uAD00\uD55C \uBC95\uB960, \uAC1C\uC778\uC815\uBCF4\uBCF4\uD638\uBC95 \uB4F1 \uC900\uC218\uD558\uC5EC\uC57C \uD560 \uAD00\uB828 \uBC95\uADDC\uC0C1\uC758 \uAC1C\uC778\uC815\uBCF4\uBCF4\uD638\uADDC\uC815\uC744 \uC900\uC218\uD558\uBA70, \uAC1C\uC778\uC815\uBCF4\uBCF4\uD638\uBC95 \uC81C30\uC870, \uC815\uBCF4\uD1B5\uC2E0\uB9DD\uC774\uC6A9\uCD09\uC9C4 \uBC0F \uC815\uBCF4\uBCF4\uD638\uC5D0 \uAD00\uD55C \uBC95\uB960 \uC81C27\uC870\uC7582\uC5D0 \uB530\uB77C \uACE0\uAC1D\uC758 \uAC1C\uC778\uC815\uBCF4 \uBCF4\uD638 \uBC0F \uAD8C\uC775\uC744 \uBCF4\uD638\uD558\uACE0 \uAC1C\uC778\uC815\uBCF4\uC640 \uAD00\uB828\uD55C \uACE0\uAC1D\uC758 \uACE0\uCDA9\uC744 \uC6D0\uD65C\uD558\uAC8C \uCC98\uB9AC\uD560 \uC218 \uC788\uB3C4\uB85D \uB2E4\uC74C\uACFC \uAC19\uC740 \uCC98\uB9AC\uBC29\uCE68\uC744 \uC81C\uC815\uD558\uACE0 \uC774\uB97C \uC900\uC218\uD558\uACE0 \uC788\uC2B5\uB2C8\uB2E4.",
                                                React.createElement("br", null),
                                                React.createElement("br", null),
                                                "- LS ELECTRIC\uC740 \uAC1C\uC778\uC815\uBCF4\uCC98\uB9AC\uBC29\uCE68\uC744 LS ELECTRIC \uD648\uD398\uC774\uC9C0(http://www.ls-electric.com)"))),
                                    React.createElement("li", null,
                                        React.createElement("div", { className: "input__area mt-8 txt-right" },
                                            React.createElement("div", { className: "radioBox" },
                                                React.createElement("label", { htmlFor: "rd1" },
                                                    React.createElement("input", { type: "radio", id: "rd1", name: "rd", value: "true", checked: (agreePersonalInfoSel == "true") ? true : false, onChange: (e) => handleAgreePersonalInfoSelSel(e) }),
                                                    "\uB3D9\uC758"),
                                                React.createElement("label", { htmlFor: "rd2" },
                                                    React.createElement("input", { type: "radio", id: "rd2", name: "rd", value: "false", checked: (agreePersonalInfoSel == "false") ? true : false, onChange: (e) => handleAgreePersonalInfoSelSel(e) }),
                                                    "\uB3D9\uC758\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4."))))))),
                        React.createElement("li", { className: "mt-80" },
                            React.createElement("div", { className: "btn__wrap right w100p" }, (agreePersonalInfoSel == "true") ?
                                React.createElement("button", { type: "button", className: " js-open", "data-pop": "pop-small", onClick: (e) => CUTIL.jsopen_Popup(e) },
                                    React.createElement("span", { "data-pop": "pop-small" }, "\uC694\uCCAD"))
                                :
                                    React.createElement("button", { type: "button", className: " js-open", "data-pop": "pop-small", onClick: (e) => disagreePop(e) },
                                        React.createElement("span", { "data-pop": "pop-small" }, "\uC694\uCCAD"))))))),
            React.createElement("ul", { className: "box__info nobg mt-90 d-sm-block" },
                React.createElement("li", null, "e-Health Portal \uC774\uC6A9 \uC911\uC5D0 \uC0DD\uAE34 \uBD88\uD3B8\uD55C \uC810\uC774\uB098 \uBB38\uC758\uC0AC\uD56D\uC744 \uBCF4\uB0B4\uC8FC\uC138\uC694. \uAD81\uAE08\uD558\uC2E0 \uC810\uC744 \uB0A8\uACA8\uC8FC\uC2DC\uBA74 \uCD5C\uCD08 \uC811\uC218\uB41C \uBB38\uC758 \uAC74\uBD80\uD130 \uC21C\uCC28\uC801\uC73C\uB85C \uB2F5\uBCC0\uC744 \uBC1B\uC73C\uC2E4 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                React.createElement("li", null, "\uC774\uBA54\uC77C \uC0C1\uB2F4\uC740 \uC2E4\uC2DC\uAC04 \uC0C1\uB2F4\uC774 \uC544\uB2C8\uBA70, \uC0C1\uB2F4\uC774 \uC9D1\uC911\uB420 \uACBD\uC6B0 \uB2F5\uBCC0\uC774 \uC9C0\uC5F0\uB420 \uC218 \uC788\uC2B5\uB2C8\uB2E4."),
                React.createElement("li", null, "\uB124\uD2B8\uC6CC\uD06C \uC7A5\uC560 \uB4F1\uC73C\uB85C \uB0B4\uC6A9 \uC800\uC7A5\uC774 \uC548 \uB420 \uC218 \uC788\uC73C\uB2C8 \uBA54\uBAA8\uC7A5 \uB4F1\uC5D0\uC11C \uC791\uC131\uD558\uC5EC \uB4F1\uB85D\uD574 \uC8FC\uC2DC\uAE30 \uBC14\uB78D\uB2C8\uB2E4.")))));
}
export default InquiryView;
function RequestDoenPop(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const success = props.success;
    const requestSaved = props.requestSaved;
    const requestDone = props.requestDone;
    const data = (props.data == null) ? null : props.data;
    const [userItem, setUserItem] = useState(null);
    useEffect(() => {
        setUserItem((data) && data.body);
    }, [(data) && data.body]);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null, (success) ? "저장 되었습니다." : "이메일 상담 문의를  하시겠습니까?")),
        React.createElement("div", { className: "popup__footer" },
            (!success) &&
                React.createElement("button", { type: "button", className: "bg-gray js-close", onClick: (e) => close(e) },
                    React.createElement("span", null, "\uCDE8\uC18C")),
            (!success) ?
                React.createElement("button", { type: "button", onClick: (e) => requestSaved(e, userItem) },
                    React.createElement("span", null, "\uD655\uC778"))
                :
                    React.createElement("button", { type: "button", onClick: (e) => requestDone(e) },
                        React.createElement("span", null, "\uD655\uC778")))));
}
function DisagreePop(props) {
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    //props
    const success = props.success;
    const requestSaved = props.requestSaved;
    const requestDone = props.requestDone;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "popup__body" },
            React.createElement("p", null, "\uAC1C\uC778\uC815\uBCF4 \uCC98\uB9AC \uBC29\uCE68\uC744 \uB3D9\uC758 \uD6C4 \uC694\uCCAD \uD558\uC138\uC694")),
        React.createElement("div", { className: "popup__footer" },
            React.createElement("button", { type: "button", onClick: (e) => close(e) },
                React.createElement("span", null, "\uD655\uC778")))));
}
function close(e) {
    var btnCommentClose = document.getElementById("pop-small");
    var body = document.body;
    var dimm = body.querySelector(".dimm");
    if (!CUTIL.isnull(btnCommentClose))
        btnCommentClose.classList.add("hidden");
    if (!CUTIL.isnull(body))
        body.setAttribute("style", "overflow-y: auto;");
    if (!CUTIL.isnull(dimm))
        dimm.setAttribute("style", "display: none; z-index: 11;");
}
